var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"prefix":"Ano","prepend-icon":"mdi-calendar","hide-details":"","dense":"","items":_vm.years,"value":_vm.value || _vm.defaultValue},on:{"change":function($event){return _vm.onChange($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }